import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  Stack,
  Typography
} from '@mui/material';
import { useEarningsCallSummaryModalQuery } from 'generated/graphql';
import {
  CustomIcons,
  PrintButton,
  WrappedMarkdown
} from 'modules/components/layer00';
import { useParams } from 'react-router-dom';



type EarningsCallSummaryModalProps = {
  onClose?: () => void;
};

export const FC = ({
  onClose
}: EarningsCallSummaryModalProps) => {
  const { companyId } = useParams();
  const queryTuple = useEarningsCallSummaryModalQuery({
    skip: !companyId,
    variables: {
      companyId: companyId ?? ''
    }
  });

  if (!companyId) {
    return null;
  }

  const listedCompany = queryTuple.data?.listedCompany;
  const earningsSummary = listedCompany?.earningsSummary;

  if (!earningsSummary) {
    return null;
  }

  return (
    <Dialog
      open
      fullScreen
      onClose={onClose}
    >
      <DialogTitle>
        <Stack
          width='100%'
          direction='row'
          alignItems='center'
          justifyContent='space-between'
        >
          <CustomIcons.LargeIcon.FC icon='COMPANYLOGOFULL' />

          <PrintButton.FC />
        </Stack>
      </DialogTitle>

      <DialogContent>
        <Stack gap='1rem'>
          <Typography variant='activityHeader'>
            {listedCompany?.ticker} Earnings Call: {earningsSummary.reportingPeriod.toUpperCase()} {earningsSummary.fiscalYear}
          </Typography>

          <Typography
            color='#A0A0A1'
            variant='activitySubHeaderPrimary'
          >
            For the earnings call occurring on {earningsSummary?.callDate.toFormat('MM/dd/yyyy')}
          </Typography>

          <Typography
            variant='h3'
            sx={{
              mb: 2
            }}
          >
            Sherlock&apos;s Earnings Summary
          </Typography>

          <Grid
            container
            rowSpacing={4}
          >
            <Grid
              item
              columns={12}
            >
              <WrappedMarkdown.FC markdownText={earningsSummary.summaryMarkdown} />
              <WrappedMarkdown.FC markdownText={earningsSummary.importantFactsAndFiguresMarkdown} />
            </Grid>

            <Grid
              item
              columns={12}
            >
              <Typography
                variant='h3'
                sx={{
                  mb: 2
                }}
              >
                Sherlock&apos;s Risk assessment
              </Typography>

              <WrappedMarkdown.FC markdownText={earningsSummary.riskAssessmentMarkdown} />
            </Grid>

            <Grid
              item
              columns={12}
            >
              <Typography
                variant='h3'
                sx={{
                  mb: 2
                }}
              >
                Analyst Q & A
              </Typography>

              <Stack rowGap={2}>
                {earningsSummary.analystQAndA.map((line, i) => (
                  <Box
                    key={i}
                    sx={{
                    }}
                  >
                    <Typography
                      variant='h5'
                      sx={{
                        mb: 0.5
                      }}
                    >
                      {line.participantName}:
                    </Typography>

                    <Typography
                      variant='formLabel'
                      sx={{
                        maxWidth: 400
                      }}
                    >
                      {line.content}
                    </Typography>

                    {(i > 0 && i % 2)
                      ? (
                        <Divider sx={{
                          my: 2,
                          maxWidth: 200
                        }}
                        />
                      )
                      : ''}
                  </Box>
                ))}
              </Stack>
            </Grid>
          </Grid>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};
